import React, { useMemo } from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const INVESTMENT_OBJECTIVE_ELEMENT_MAX_WIDTH = 400;

const styles = (theme) => ({
  investmentObjectives: {
    width: '100%',
  },
  investmentSectionTitle: {
    fontSize: theme.typography.fontSize1Rem,
    marginBottom: 26,
  },
  investmentObjectiveTimeHorizons: {
    marginBottom: theme.spacing(3),
    display: 'flex',
    flexWrap: 'wrap',
  },
  investmentObjectiveTimeHorizon: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
    maxWidth: INVESTMENT_OBJECTIVE_ELEMENT_MAX_WIDTH,
    width: '100%',
    borderRadius: theme.radius.md,
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2.25, 3),
  },
  investmentObjectiveTimeHorizonPrompt: {
    fontSize: theme.typography.fontSize1Pt25Rem,
    marginBottom: 25,
  },
  investmentObjectiveTimeHorizonValues: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  investmentObjectiveTimeHorizonValue: {},
  investmentObjectiveTimeHorizonValueTitle: {
    marginBottom: 9,
  },
  investmentObjectiveTimeHorizonValueData: {
    lineHeight: 1,
    fontSize: 20,
  },
  investmentObjectiveTimeHorizonValueContainer: {

  },
});

function InvestmentObjectiveTimeHorizons({
  classes,
}) {
  const {
    resource,
  } = useMetaLayoutContext();
  const [sectionDataResource] = resource.attr('sectionData');
  const investmentObjectiveTimeHorizons = useMemo(() => sectionDataResource.attr('investmentObjectiveTimeHorizons')?.resources().list() || [], [sectionDataResource.attr('investmentObjectiveTimeHorizons')]);
  const investmentObjectiveTimeHorizonsValues = useMemo(() => {
    const data = {};
    if (investmentObjectiveTimeHorizons) {
      for (const investmentObjectiveTimeHorizon of investmentObjectiveTimeHorizons) {
        data[investmentObjectiveTimeHorizon.id()] = investmentObjectiveTimeHorizon.attr('values')?.resources().list() || [];
      }
    }
    return data;
  },
  [investmentObjectiveTimeHorizons]);

  return investmentObjectiveTimeHorizons.length ? (
    <div className={classes.investmentObjectives}>
      <Typography color="primary" className={classes.investmentSectionTitle}>Investment Objectives with Facet:</Typography>

      <div className={classes.investmentObjectiveTimeHorizons}>
        {investmentObjectiveTimeHorizons.map(investmentObjectiveTimeHorizon => (
          <div className={classes.investmentObjectiveTimeHorizon} key={investmentObjectiveTimeHorizon.id()}>
            <Typography className={classes.investmentObjectiveTimeHorizonPrompt} color="primary" weight="bold">
              {investmentObjectiveTimeHorizon.attr('prompt')}
            </Typography>
            <div className={classes.investmentObjectiveTimeHorizonValues}>
              {investmentObjectiveTimeHorizonsValues[investmentObjectiveTimeHorizon.id()].map(investmentObjectiveTimeHorizonValue => (
                <div className={classes.investmentObjectiveTimeHorizonValue}>
                  <Typography weight="medium" className={classes.investmentObjectiveTimeHorizonValueTitle}>{investmentObjectiveTimeHorizonValue.attr('title')}</Typography>
                  <Typography color="primary" weight="medium" className={classes.investmentObjectiveTimeHorizonValueData}>{investmentObjectiveTimeHorizonValue.attr('value')}</Typography>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : null;
}

InvestmentObjectiveTimeHorizons.propTypes = {
  classes: PropTypes.object.isRequired,
};

InvestmentObjectiveTimeHorizons.defaultProps = {};

export default withStyles(styles)(InvestmentObjectiveTimeHorizons);
